<template>
    <ClassroomLayout>
        <template v-if="minutesPastStart > 90">
            <template v-if="theme === 'free'">
                <div class="classroom-late">
                    <h3>This lesson has ended.</h3>
                    <p>
                        Please book in for another free coding lesson...
                    </p>
                </div>

                <div :class="'classroom-late-button'">
                    <div class="button button-big" @click="rebookClick">Rebook now</div>
                </div>
            </template>
            <template v-else>
                <div class="classroom-late">
                    <h3>This lesson has ended.</h3>
                    <p>
                        Don't worry if you missed it, we'll send you an email with a recorded version of this lesson, so
                        that you can catch up on the project before your next class.
                    </p>
                </div>
            </template>
        </template>

        <template v-else>
            <template v-if="theme === 'free'">
                <div class="classroom-late">
                    <h3>Sorry. Today's lesson has already started.</h3>
                    <p>
                        Because the lesson is already underway, joining now would interrupt the students who are already
                        learning. Instead, please book in for another free coding class...
                    </p>
                </div>

                <div :class="'classroom-late-button'">
                    <div class="button button-big" @click="rebookClick">Rebook now</div>
                </div>
            </template> 
            <template v-else>
                <div class="classroom-late">
                    <h3>Sorry. Today's lesson has already started.</h3>
                    <p>
                        Because the lesson is already underway, joining now would interrupt the students who are already
                        learning.
                    </p>
                    <p>
                        But don't worry - we'll send you an email with a recorded version of this class, so that
                        you can catch up on the project before your next class.
                    </p>
                </div>
            </template>
        </template>
    </ClassroomLayout>
</template>

<script setup>
import { computed } from "vue";
import ClassroomLayout from "@/components/classroom/ClassroomLayout.vue";

const props = defineProps({
    startTimeUtc: Number, // The millisecond timestamp from MySQL
    theme: String
});

// Calculate how many minutes have elapsed since the lesson started
const minutesPastStart = computed(() => {
    if (!props.startTimeUtc) return 0;
    const diffMs = Date.now() - props.startTimeUtc;
    return diffMs / (1000 * 60);
});

function rebookClick() {
    window.location.href = 'https://www.cococoders.com/book/free';
}
</script>

<style lang="scss" scoped>
.classroom-late {
    text-align: center;
    max-width: 600px;
    padding: 0 20px;
    margin: 0 auto;

    &-button {
        display: flex;
        justify-content: center;
        margin-top: 2rem;
    }

    h3 {
        margin-bottom: 50px
    }
}
</style>
